<div class="sp-p-16">
  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Basic Message:</h4>
    <button ui-button [buttonType]="'primary'" (click)="createBasicMessage()">Display normal message</button>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Various Message Types:</h4>
    <button ui-button (click)="createMessage('success')">Success</button>
    <button ui-button (click)="createMessage('error')">Error</button>
    <button ui-button (click)="createMessage('warning')">Warning</button>
  </div>

  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Showing Consecutive Messages:</h4>
    <button ui-button [buttonType]="'default'" (click)="startShowMessages()">Display a sequence of messages</button>
  </div>
</div>
